import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from './views/Home.vue'
import AuthMiddleware from './middleware/auth'
Vue.use(VueRouter)

const routes = [
  {
    meta: {
      title: 'Dashboard',
      requiresAuth: true
    },
    path: '/dashboard',
    name: 'home',
    beforeEnter: AuthMiddleware,
    component: Home
  },
  {
    meta: {
      title: 'Editar',
      requiresAuth: true
    },
    path: '/dashboard/questions-edit',
    name: 'QuestionsEdit',
    redirect: '/',
    component: () => import(/* webpackChunkName: "questions-edit" */ './views/QuestionsEdit.vue'),
    props: true
  },
  {
    meta: {
      title: 'Cargar',
      requiresAuth: true
    },
    path: '/dashboard/users-load',
    beforeEnter: AuthMiddleware,
    name: 'UserLoad',
    component: () => import(/* webpackChunkName: "questions-edit" */ './views/UsersLoad.vue'),
    props: true
  },
  {
    path: '/full-page',
    component: () => import(/* webpackChunkName: "full-page" */ './views/FullPage.vue'),
    children: [
      {
        meta: {
          title: 'Login'
        },
        path: '/login',
        name: 'login',
        component: () => import(/* webpackChunkName: "full-page" */ './views/full-page/Login.vue')
      },
      {
        meta: {
          title: 'StartClaim'
        },
        path: '/start-claim',
        name: 'claim',
        component: () => import(/* webpackChunkName: "start-claim" */ './views/full-page/StartClaim.vue')
      },
      {
        meta: {
          title: 'AnswerQuestions'
        },
        path: '/answer-questions',
        name: 'AnswerQuestions',
        component: () => import(/* webpackChunkName: "answer-questions" */ './views/full-page/AnswerQuestions.vue')
      }
    ]
  },
  {
    path: '*',
    redirect: 'start-claim'
  }
]

const router = new VueRouter({
  base: process.env.BASE_URL,
  mode: 'history',
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

router.beforeEach((to, from, next) => {
  next()
})
export default router
